<template>
  <div class="page-wrapper viewQuotes-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      
      <div class="page-title">
        <h1>Personalized Quoting System (PQS)</h1>
        <button class="clear-search" @click="clearSearch">Clear Search</button>
      </div>
      <div class="pqs-tabs titleTab mt-3">
        <div class="quote-type-btns">
          <button
            class="view-quote-btn"
            :class="{ active: activeListName == 'individual' }"
            @click="viewIndividualQuotes"
          >
            View Individual Quote
          </button>
          <button
            class="view-quote-btn"
            :class="{ active: activeListName == 'group' }"
            @click="viewGroupQuotes"
          >
            View Group Quote
          </button>
        </div>
        <div class="quote-action-btns">
          <button
            v-if="activeListName == 'individual'"
            class="new-quote-btn individual-new-quote-btn mt-0 new-quote px-3"
            type="submit"
            @click.prevent='renderPersonalizedModal'
          >
            + Quote Individual Client
          </button>
          
          <button
            v-if="activeListName == 'group'"
            type="submit"
            @click.prevent='renderPQSQuote'
            class="new-quote-btn px-3 mt-0 new-quote"
          >
            <span><img src="../../assets/images/groupQuote.svg"
                      width="25" height="17" /></span>
            <span> 
              PQS - Groups </span>
          </button>
          <button
            v-if="activeListName == 'group'"
            class="new-quote-btn mt-0 px-3 new-quote"
            type="submit"
            @click.prevent="renderGroupQouteModal"
          >
            + Quote Group Client
          </button>
          
        </div>
      </div>
      <quote-filter :filters="quoteFilters" @onSearch="getFilteredRecords" />
      <div class="quote-card pt-3">
        <div class="top-pagination">
          <div class="view-quote-pagination">
            <pagination
              v-if="activeListName == 'group'"
              :rows.sync="computedGroupQuotes"
              :filters="quoteFilters"
            />
            <pagination
              v-if="activeListName == 'individual'"
              :rows.sync="quoteList"
              :filters="quoteFilters"
            />
          </div>
        </div>
        <div v-if="activeListName == 'individual'">
          
          <quote-list :quoteList="quoteList" @reloadQuotes="reloadQuotes"/>
          <pagination :rows.sync="quoteList" :filters="quoteFilters" />
        </div>

        <div v-if="activeListName == 'group'">
          <group-census-table :groupCensusList="computedGroupQuotes" @reloadQuotes="reloadQuotes" />
          <pagination :rows.sync="computedGroupQuotes" :filters="quoteFilters" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QuoteFilter from "../ViewQuotes/partials/QuoteFilter.vue";
import QuoteList from "../ViewQuotes/partials/QuoteList.vue";
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import GroupCensusTable from "../../views/GroupCensus/partials/GroupCensusTable.vue";

const filters = {
  agent_name: "",
  agent_code: "",
  status: "",
  start_date: "",
};
export default {
  name: "ViewQuotes",
  components: {
    QuoteFilter,
    QuoteList,
    GroupCensusTable,
  },
  data() {
    return {
      quoteFilters: { ...filters },
      quoteList: [],
      breadcrumbItems: [{ title: "Personalized Quoting System (PQS)", active: true }],
      activeQuoteList: "individual",
      groupQuoteList: [],
      groupQuotePagination: {},
    };
  },
  computed: {
    activeListName() {
      return this.$store.getters.activeList;
    },
    computedGroupQuotes() {
      return this.$store.getters.groupQuoteCollection;
    },
    computedIndividualQuotes(){
      return this.$store.getters.individualQuoteCollection;
    }
  },
  methods: {
    async getQuoteList(filters = {}) {
      let url = "v2/quote/list";
      if (Object.keys(filters).length) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `${url}?${filterUrl}`;
        this.getFilteredIndividualQuotes(filterUrl);
        this.getFilteredGroupQuotes(filterUrl);
      }
      let loader = this.$loading.show();
      await Api.get(url)
        .then((res) => {
          this.quoteList = res.data;
        })
        .catch(() => {
          this.quoteList = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
    getFilteredRecords(filters) {
      this.getQuoteList(filters);
    },
    clearSearch() {
      this.quoteFilters = { ...filters };
      this.getQuoteList(this.quoteFilters);
    },
    viewGroupQuotes() {
      this.$store.commit("setActiveList", "group");
    },
    viewIndividualQuotes() {
      this.$store.commit("setActiveList", "individual");
    },
    //filter individual quotes
    async getFilteredIndividualQuotes(filterParams) {
      const url = `v2/quote/list?${filterParams}`;
      let loader = this.$loading.show();
      await Api.get(url)
        .then((res) => {
          this.$store.commit("setIndividualQuotes", res.data);
          this.quoteList = res.data;
        })
        .catch(() => {
          this.quoteList = [];
        })
        .finally(() => {
          loader.hide();
        });
    },

    //filter group quotes
    async getFilteredGroupQuotes(filterParams) {
      const url = `v2/quote/group-quotes?${filterParams}`;
      let loader = this.$loading.show();
      await Api.get(url)
        .then((response) => {
          const responseData = response.data;
          this.$store.commit("setGroupQuotes", responseData);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    renderPersonalizedModal() {
      let app = this
      app.$bvModal.show('personalized-quote-modal')
    },
    renderGroupQouteModal() {
      this.$bvModal.show('group-quote-modal');
    },
    renderPQSQuote () {
      let app = this
      app.$router.push('/view-group-quote')
    },
    reloadQuotes() {
      this.getQuoteList(this.quoteFilters);
    }
  },

  created() {
    this.getQuoteList();
    this.$store.dispatch("fetchGroupQuotes");
    this.$store.dispatch("fetchIndividualQuotes");
  },
};
</script>
<style src="../../assets/css/view-quotes.css"></style>
<style scoped>
.quote-card .top-pagination {
  margin-bottom: 20px;
}

.view-quote-btn {
  border: 0.15rem solid grey;
  background-color: transparent;
  padding: 0.25rem 0.85rem;
  border-radius: 1.5rem;
  color: grey;
}
.pqs-tabs .view-quote-btn {
  color: #03c3ec;
  border: 1px solid #03c3ec;
  padding: 7px 30px;
}

.active {
  color: rgb(255, 255, 255);
  transition: 0.25s ease-in-out;
  background: transparent
    linear-gradient(180deg, #00ccff 0%, #1597b8 49%, #0567bc 100%) 0% 0%
    no-repeat padding-box;
  color: #fff !important;
  box-shadow: 0px 8px 20px -13px rgb(0 0 0 / 69%);
  padding: 7px 30px;
}

.titleTab{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.quote-type-btns,
.quote-action-btns {
  display: flex;
  gap: 0.75rem;
}
.new-quote-btn{
  display: flex;
  justify-content: center;
  align-items: center;
  width: unset;
}
.quote-action-btns button span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.quote-action-btns button img {
  flex-shrink: 0;
}

@media (max-width:800px ) and ( min-width:768px) {
  .titleTab div{
    gap: 5px;
  }
}
@media (max-width:768px) {
  .titleTab{
    flex-direction: column;
    align-items: stretch;
    gap:1rem;
  }
  .titleTab .quote-type-btns .view-quote-btn,
  .titleTab .quote-action-btns .new-quote-btn{
    flex-shrink: 1;
    flex-grow: 1;
    max-width: none;
  }
  .titleTab .quote-action-btns .individual-new-quote-btn{
    flex-grow: 0.3;
  }
}
@media (max-width: 650px) {
  .view-quote-pagination .pagination-wrap {
    display: block;
  }
}
@media (max-width:576px) {
  .titleTab .quote-type-btns,
  .titleTab .quote-action-btns {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
}
</style>